<script>
  import { onMount } from "svelte";
  import { makeWebsiteRequest } from "../../Common/tools";
  import {External, M} from "../../external";
  import {WHATSAPP} from "../static";

  export let campaign;
  let sendType = "now";
  let delayTimestamp = null;

  let send = async () => {

    const message = campaign.content;

    if(sendType === "now" || sendType === "later") {
      if(campaign.type === WHATSAPP && !message.templateApproved) {
        External.Tools.showError(M.WHATSAPP_CAMPAIGN_TEMPLATE_NOT_APPROVED);
        return;
      }
    }

    campaign.delayTimestamp = sendType === "later" ? delayTimestamp : null;
    let response = await makeWebsiteRequest({
      action: "queueMessageCampaign",
      method: "post",
      data: {
        data: JSON.stringify(campaign),
        makeDraft: sendType === "draft"
      }
    });

    if (!response) return;

    if (sendType !== "draft") {
      External.Tools.showWindow({
        noNav: true,
        noTitle: true,
        width: 500,
        withDarkBackground: true,
        isModal: false,
        markup: External.format(External.Templates.get("marketingCampaignSentConfirmation"), "message", sendType === "now" ? M.CAMPAIGN_STARTED : M.CAMPAIGN_SCHEDULED)
      });
    }
    External.CPanel.goToUrl("/me/crm/marketing/campaigns", true);
  };

  onMount(function () {
    let datepicker = External.$(".datepicker").datetimepicker({
      minDate: new Date(),
      dateFormat: External.WebsiteSettings.getDateFormat() === "us" ? "mm/dd/yy" : "dd/mm/yy",
      currentText: M.TIME_NOW,
      closeText: M.CLOSE,
      timeText: M.TIME,
      hourText: M.TIME_HOUR,
      minuteText: M.TIME_MINUTE,
      secondText: M.SECONDS,
      monthNamesShort: [M.JAN, M.FEB, M.MAR, M.APR, M.MAY_SHORT, M.JUN, M.JUL, M.AUG, M.SEP, M.OCT, M.NOV, M.DEC],
      monthNames: [M.JANUARY, M.FEBRUARY, M.MARCH, M.APRIL, M.MAY, M.JUNE, M.JULY, M.AUGUST, M.SEPTEMBER, M.OCTOBER, M.NOVEMBER, M.DECEMBER],
      onSelect: function () {
        delayTimestamp = External.$(this).datepicker("getDate").toJSON();
      }
    });

    if (campaign.delayTimestamp != null) {
      datepicker.datepicker("setDate", campaign.delayTimestamp);
      delayTimestamp = campaign.delayTimestamp;
      sendType = "later";
    }

    if (!campaign.data) campaign.data = {};

  });
</script>

<div class="flex-1 overflow account-settings store-products">
  <div class="col20 f-left">
    <div class="top-background-wrapper wide-top-background">
      <div class="top-background" style="max-width: 850px;">
        <div class="text-wrapper" />
      </div>
    </div>
    <div class="content-wrapper horizontal-flex-table" style="max-width: 850px; margin-top: 100px;">
      <div class="sections-wrapper members-wrapper horizontal-flex-table">
        <div class="section-bg members-wrapper products-wrapper crm-table-outer" style="box-shadow: none; padding: 0;">
          <div class="system-emails-wrapper">
            <div class="col20 f-left t-center mb-15"><span class="material-icons-outlined fingerprint-icon" style="font-size: 26px;"> send </span></div>
            <h2 class="col20 f-left t-center" style="font-size: 26px;">{M.SEND_CAMPAIGN}</h2>
            <div class="col20 f-left email-section-description t-center mt-10 mb-25">{M.SEND_CAMPAIGN_QST}</div>
            <div class="col20 f-left mt-15 flex flex-col justify-center">
              <div class="email-inputs-wrapper" style="max-width: 300px">
                <div class="popup-input-wrapper mb-0">
                  <h5 class="ta-center">{M.SEND_WHEN}</h5>
                  <div class="checkbox-wrapper mt-25">
                    <input id="send-campaign-draft-cbx" class="css-checkbox" type="radio" value="draft" bind:group={sendType} />
                    <label for="send-campaign-draft-cbx" class="css-label">{M.DRAFT}<span>{M.SAVE_AS_DRAFT}</span></label>
                  </div>
                  <div class="checkbox-wrapper mt-15">
                    <input id="send-campaign-now-cbx" class="css-checkbox" type="radio" value="now" bind:group={sendType} />
                    <label for="send-campaign-now-cbx" class="css-label">{M.NOW}<span>{M.NOW_SEND}</span></label>
                  </div>
                  <div class="checkbox-wrapper mt-15">
                    <input id="send-campaign-later-cbx" class="css-checkbox" type="radio" value="later" bind:group={sendType} />
                    <label for="send-campaign-later-cbx" class="css-label">{M.LATER}<span>{M.LATER_SEND}</span></label>
                  </div>
                </div>
                <div class="popup-input-wrapper email-date-input-wrapper mb-15" style="margin-left: 37px" class:none={sendType !== "later"}>
                  <input class="datepicker" placeholder={M.SELECT_DATE_TIME} />
                </div>
                <div class="col20 f-left flex justify-center mt-35 mb-35">
                  <a on:click={send} class="big-button blue circle-effect transition-bg f-left" style="margin-left:5px;">
                    {sendType === "draft" ? M.SAVE_AS_DRAFT : M.SEND_CAMPAIGN}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
